class Check {
   isTestEnvironment() {
      return window.location.hostname.includes('bussup') || window.location.hostname.includes('localhost');
   }
   isDesktop() {
      return window.innerWidth > 768;
   }
}

export default new Check();
